import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { gapi } from 'gapi-script';
import { toast } from 'react-toastify';
import { GoogleLogin } from 'react-google-login';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import GoogleIcon from '@mui/icons-material/Google';
import { useGoogleLoginMutation } from '../../../../store/api/authApi';
import { setCredentials } from '../../../../store/auth/authSlice';

const GoogleLoginButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'pageLogin',
})(({ pageLogin, theme }) => ({
  ...(!pageLogin && {
    marginLeft: '40px',
    marginTop: '30px',
    [theme.breakpoints.down('md')]: {
      marginLeft: '28px',
      marginTop: '20px',
    },

    [theme.breakpoints.down('400')]: {
      marginLeft: '30px',
      marginTop: '20px',
    },
    [theme.breakpoints.down('350')]: {
      marginLeft: '22px',
      marginTop: '7px',
      fontSize: '12px',
      lineHeight: '14px',
    },
  }),
  ...(pageLogin && {
    marginLeft: '-8px',
    marginRight: '-8px',
  }),
  width: 'max-content',
  justifyContent: 'flex-start',
  padding: '6px 8px',
  '& div:not(.MuiTouchRipple-root)': {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    textTransform: 'none',
    fontSize: '14px',
    lineHeight: '16px',
    gap: '10px',
    color: '#fff',
    '& svg': {
      width: '26px',
      height: '26px',
      padding: '2px',
      backgroundColor: 'transparent',
      [theme.breakpoints.down('350')]: {
        width: '20px',
        height: '20px',
      },
    },
  },
}));

const GoogleLoginBtn = (props) => {
  const [checked, setChecked] = useState(false);
  const [
    googleLogin,
    {
      data: loginData,
      isSuccess: isLoginSuccess,
      isError: isLoginError,
      error: loginError,
    },
  ] = useGoogleLoginMutation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoginSuccess) {
      localStorage.setItem('checked', checked);
      dispatch(setCredentials(loginData.data));

      if (props.pageLogin) {
        // login page redirect
        props.handleLogin();
      } else {
        // login modal
        props.closeAfterLogin();
        props.handleLoginChange(true);
      }

      toast.success(`Hi,${loginData.data.userName}`);
    }
    if (isLoginError) {
      if (loginError.status === 404) {
        toast.error('Google user login failed, try again');
      } else {
        toast.error('Google login failed');
      }
    }
  }, [isLoginSuccess, isLoginError]);

  const onSuccess = async (response) => {
    await googleLogin({ tokenId: response.tokenId });
  };

  const onFailure = (response) => {
    toast.error('Google login failed, please contact the admin');
  };

  useEffect(() => {
    gapi.load('client:auth2', start);
  }, []);

  function start() {
    gapi.client.init({
      clientId: process.env.REACT_APP_CLIENT_ID,
      scope: 'profile email',
    });
  }

  return (
    <GoogleLoginButton pageLogin={props.pageLogin}>
      <GoogleLogin
        clientId={process.env.REACT_APP_CLIENT_ID}
        onSuccess={onSuccess}
        onFailure={onFailure}
        render={(renderProps) => (
          <div onClick={renderProps.onClick} disabled={renderProps.disabled}>
            Sign in with <GoogleIcon />
          </div>
        )}
      />
    </GoogleLoginButton>
  );
};

export default GoogleLoginBtn;
